import { type ComponentType, type Context, createContext } from 'react';

import { type ModalComponentProps } from '../modal-trigger/types';

export type ModalComponent = ComponentType<ModalComponentProps>;

export type ModalContextValue = {
	openModal: (component: ModalComponent) => void;
};

export const defaultModalContext: ModalContextValue = {
	openModal: () => {
		throw new Error(
			"To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';",
		);
	},
};

export const ModalContext: Context<ModalContextValue> = createContext(defaultModalContext);
